import React from 'react';
import "./KeyPoints.css";

const KeyPoints = ({ points,title}) => {
  return (
    <div className="keypoints-container">
      <h2 className="keypoints-title">{title}</h2>
      <ul className="keypoints-list">
        {points.map((item, index) => (
          <li key={item._id.$oid} className="keypoint-item">
            <span className="keypoint-icon">{index + 1}</span>
            <span className="keypoint-text">{item.points}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default KeyPoints;
